import { ProductAvailabilityTemplateListPage } from '@/features/product-availability-template/pages/ProductAvailabilityTemplateListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-availability-template/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_availability_template.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAvailabilityTemplateListPage,
})
